import React, { Component } from 'react';
import styles from '../../../Assets/CSS/stylesheet_UHS';
import Grid from '@material-ui/core/Grid';
import {AppBar, Tabs, Tab, FormControl, InputLabel, Select} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import AccountCircle from '@material-ui/icons/AccountCircle';
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Auth } from 'aws-amplify';
import axios from "axios";
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import './window.css';
import Configuration from "../../../configurations";
import Loader from "../../loader";
import {Modal,Row,Col,Form} from "react-bootstrap";
import customStyle from "../../../Assets/CSS/stylesheet_UHS"
import MuiPhoneNumber from "material-ui-phone-number";
import AccordonCommon from '../../CommonScreens/AccordonCommon';
import {withStyles} from "@material-ui/core/styles";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Button from "@material-ui/core/Button";
import Sample from "../../CommonScreens/sampleTextField";
import SampleName from '../../CommonScreens/sampleTextFieldName';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import ClearIcon from '@material-ui/icons/Clear';
import Tooltip from '@material-ui/core/Tooltip';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import CloseIcon from '@material-ui/icons/Close';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import AddIcon from '@material-ui/icons/Add';
import FileUploadTwoToneIcon from '@mui/icons-material/FileUploadTwoTone';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import CircularProgress from '@material-ui/core/CircularProgress';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { Dialog as MuiDialog, Alert as MuiAlert, CircularProgress as MuiCircularProgress } from '@mui/material';
import configurations from "../../../configurations";
import { withRouter } from 'react-router-dom';
import { getQueryParams, getResolvedEmployerEmpid, getEmployerScopedEmpidForApi } from '../../authentication/utils';
import '../../../Assets/CSS/FullModal.css';
import './ProfileSettingsModal.css';
import PasswordValidations from '../../authentication/PwdValidations';

const CustomButton = withStyles(
    customStyle.viewBtn
)(Button);

const NextButton = withStyles(
    customStyle.doneBtn
)(Button);


// 4-second countdown ring for the feedback toast; calls onDone when it reaches 0.
const FeedbackCountdown = ({ seconds = 4, onDone }) => {
    const [remaining, setRemaining] = React.useState(seconds);
    const onDoneRef = React.useRef(onDone);
    onDoneRef.current = onDone;
    React.useEffect(() => {
        const interval = setInterval(() => setRemaining((r) => r - 1), 1000);
        const timeout = setTimeout(() => onDoneRef.current(), seconds * 1000);
        return () => { clearInterval(interval); clearTimeout(timeout); };
    }, [seconds]);
    return (
        <span style={{ position: 'relative', display: 'inline-flex', marginRight: 28 }}>
            <MuiCircularProgress variant="determinate" value={(Math.max(remaining, 0) / seconds) * 100} size={28} thickness={4} sx={{ color: '#fff' }} />
            <span style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 600, color: '#fff' }}>{Math.max(remaining, 0)}</span>
        </span>
    );
};

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLogged: false,
            loaderShow : false,
            association_logo : '',
            anchorEl:null,
            open:false,
            userName : '',
            profileModal : false,
            profileModalMaximized : false,
            profileActiveTab : 0,
            licenses : [],
            licensesLoading : false,
            licensesFetched : false,
            noStatesToAdd : false,
            licenseMenuAnchorEl : null,
            licenseMenuRowId : null,
            updateLicenseModal : false,
            updateLicenseModalMaximized : false,
            updateLicenseForm : null,
            updateLicenseStates : [],
            updateLicenseSaving : false,
            updateLicenseDocUploading : false,
            updateLicenseDocErr : '',
            products : [],
            productsLoading : false,
            productsFetched : false,
            addressSuggestions : [],
            addressSuggestionsOpen : false,
            currentPassword : '',
            newPassword : '',
            confirmPassword : '',
            newPasswordValid : false,
            feedbackMsg : null,
            showCurrentPassword : false,
            showNewPassword : false,
            showConfirmPassword : false,
            empProfileModal : false,
            fname:'',
            lname:'',
            email:'',
            phone:'',
            countryCode : '',
            desc : '',
            npnNumber : '',
            addressline1 : '',
            addressline2 : '',
            city : '',
            zip : '',
            imageName : '',
            imagePath : '',
            agentValid : false,
            agentURL: '',
            defaultCountryCode : "",
            imageErr : '',
            rightBar: false,
            switchArray : [],
            countData: "",
            topbarData:null,
            postobj: {},
            modeList: sessionStorage.getItem("modeList") ? JSON.parse(sessionStorage.getItem("modeList")) : [],
            mode:  sessionStorage.getItem("mode") || "",
            ChannelName:localStorage.getItem("channelName")?localStorage.getItem("channelName"): sessionStorage.getItem("clientName"),
            cropModal: false,
            imageSrc: null,
            croppedImage: null,
            selectedFile: null,
            cropBox: { x: 50, y: 50, width: 200, height: 200 },
            isDragging: false,
            isResizing: false,
            resizeCorner: null,
            dragStart: { x: 0, y: 0 },
        };
    }

    openProfileFromEvent = () => this.handleOption('Profile');

    componentWillUnmount() {
        window.removeEventListener('OPEN_AGENT_PROFILE', this.openProfileFromEvent);
    }

    componentDidMount() {
        // The Manage Profile button in the page's agency bar asks the header to open the profile.
        window.addEventListener('OPEN_AGENT_PROFILE', this.openProfileFromEvent);
        this.setState({
            userName : sessionStorage.getItem('username')
        });
        this.getTopBarData();
        this.state.isLogged = sessionStorage.getItem('isLogged');
        let queryParams = getQueryParams();
        const resolvedEmpid = getEmployerScopedEmpidForApi(queryParams && queryParams.empid);
        if (resolvedEmpid) {
            this.setState({ empid: resolvedEmpid });
            this.getTotalEmpInfo(resolvedEmpid);
        }
        let data = {
            "clientId" : this.props.clientId
        }
        axios.post(configurations.baseUrl.replace("agent", "enrollment") + 'getClient', data)
            .then(response=>{
                if(response.data.response){
                    this.setState({
                        agentURL : configurations.AGENT_BASE_URL + response.data.response.clientName + '/' + this.props.agentId
                    })  
                }
            });
            axios.get(process.env.REACT_APP_BASE_URL + 'getChannelListByAgentId/' + sessionStorage.getItem('parentBrokerId'))
            .then(response =>{
                this.setState({switchArray: response.data.response})
            })
        
         let countryCode = '+1';
          if(Intl.DateTimeFormat().resolvedOptions().timeZone == "Asia/Calcutta"){
                    countryCode = "+91";
                }
                  this.setState({
                    defaultCountryCode : countryCode
                });
        this.getClientProfile();
    }
    handleClose = () => {
        this.setState({open:false,anchorEl:null})
    };


    getTopBarData = () => {
        if(sessionStorage.getItem('USER_DATA')){


            axios.get(process.env.REACT_APP_BASE_URL + 'employer/getClientInfo/' + JSON.parse(sessionStorage.getItem('USER_DATA')).clientId).then(response => {
                sessionStorage.setItem('customerServiceNo', response.data.response.customerServiceNo);
                const typesOfClients = response.data.response.clientType?.replace("Agents,","").split(",") || ["Households"];
                     const params = new URLSearchParams(window.location.search);
                     const transformedArray = typesOfClients.map(item => ({
                        label: `Work with ${item}`
                      }));
                     sessionStorage.setItem("modeList", JSON.stringify(transformedArray))
                     const empid = params.get("empid");
                     if(localStorage.getItem("statusCd") && localStorage.getItem("statusCd") === "ACTIVE")
                     if(!this.state.mode && window.location.pathname === "/"){
                         this.setState({mode: transformedArray[0].label}, () => {
                            if(this.state.mode === "Work with Employers"){
                                window.location.href = "/manage-employers"
                            } else if (this.state.mode === "Work with Households"){
                                window.location.href = "/manage-prospects"
                            }
                         })
                     } else if (window.location.pathname === "/manage-prospects" && !empid) {
                         this.setState({mode: transformedArray[0].label})
                     } else if (window.location.pathname === "/manage-employers" || empid) {
                         this.setState({mode:  transformedArray[1].label})
                     }
             })

        }
      
    }
    getModeSelect = (value) => {
        sessionStorage.setItem("mode", value)
        if(value === "Work with Employers"){
            window.location.href = "/manage-employers" 
        } else if(value === "Work with Households") {
            window.location.href = "/manage-prospects"
        }
    }


    logoutHandler = (event) => {
        this.setState({
            loaderShow : true
        });
        Auth.signOut();
        localStorage.clear();
        sessionStorage.clear();
        localStorage.setItem('isLogged', false);
        sessionStorage.setItem('isLogged', false);
        window.location.href = '/login';
    }

    getTotalEmpInfo = (empid) => {
        const id = getResolvedEmployerEmpid(empid);
        if (!id) {
            return;
        }
        axios.get(configurations.baseUrl + '/enrollment/getCountsFormEmployer/' + encodeURIComponent(id))
            .then(response =>{
                console.log(response);
                if(response.data.code === 200){
                    this.setState({
                        countData : response.data.response,
                    })
                }
            })
    }

    formatPhoneNumber = (phoneNumberString) => {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          var intlCode = (match[1] ? '+1 ' : '');
          return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        }
        return null;
      }


      captureEvents = async (agentId, email, eventState) => {
        try {
          let data = {
            agentId: agentId,
            eventState: eventState,
            createdBy: String(email).toLowerCase(),
          };
          let apiPath = process.env.REACT_APP_BASE_ROOT_URL + `/veraagency/api/v1/agent-event`;
          const response = await axios.post(apiPath, data);
          const responseData = response.data;
          return responseData;
        } catch (error) {
          console.error("API call failed", error);
        }
      };

    handleOption = async (option) => {
        this.setState({
            loaderShow : true
        });
        if(option === "Sign Out"){
            await this.captureEvents(this.props.agentId, sessionStorage.getItem("email"), "LOGOUT")
            Auth.signOut();
            localStorage.clear();
            sessionStorage.clear();
            localStorage.setItem('isLogged', false);
            sessionStorage.setItem('isLogged', false);
            window.location.href = '/login';
        } else if(option === 'Profile'){
            this.clearData();    
            let email = sessionStorage.getItem('email');
            let url = "";
            if (process.env.REACT_APP_PORTAL == 'employer') {
                const eid = getResolvedEmployerEmpid();
                if (!eid) {
                    this.setState({ loaderShow: false });
                    return;
                }
                url = `${process.env.REACT_APP_BASE_URL}/employer/getEmployerByEmpId/${encodeURIComponent(eid)}`;
            }
            else url = `${process.env.REACT_APP_BASE_ROOT_URL}/veraagency/api/v1/agent/${this.props.agentId}`
            axios.get(url)
                .then(response => {

                    if(response.data.response){
                        let countyCode = '+1';
                        let phone = '';
                        if(response.data.response.phone){
                            if(response.data.response.phone.length === 13){
                                countyCode = response.data.response.phone.substr(0,3);
                                phone = this.formatPhoneNumber(response.data.response.phone.substr(2));
                            } else {
                                countyCode = response.data.response.phone.substr(0,2);
                                phone = this.formatPhoneNumber(response.data.response.phone);
                            }
                        } else {
                            countyCode = this.state.defaultCountryCode;
                            phone = '';
                        }

                        let filePath = response.data.response.image ? response.data.response.image.split('/') : [];
                        let fileName = '';

                        if(filePath.length > 0){
                            fileName = filePath[filePath.length - 1];
                        }

                        if (process.env.REACT_APP_PORTAL == 'employer') {
                            this.setState({
                            fname: response.data.response.firstName,
                            lname: response.data.response.lastName,
                            email: response.data.response.email,
                            phone: phone,
                            desc: response.data.response.description ? response.data.response.description : '',
                            imagePath: response.data.response.image,
                            imageName: fileName,
                            countryCode: countyCode,
                            imageErr: '',
                            loaderShow: false,
                            empProfileModal: true,
                            open: false,
                            anchorEl: null
                        }, () => this.checkValidation());
                        } else {
                        this.setState({
                            id: response.data.response.id,
                            agentId : response.data.response.brokerId,
                            fname : response.data.response.firstName,
                            lname : response.data.response.lastName,
                            email : response.data.response.email,
                            phone : phone,
                            desc : response.data.response.description ? response.data.response.description : '',
                            imagePath : response.data.response.image,
                            imageName : fileName,
                            countryCode : countyCode,
                            imageErr : '',
                            loaderShow : false,
                            profileModal : true,
                            open:false,
                            anchorEl:null
                        }, () => this.checkValidation());
                        }
                    } 
                    else if(response.data.data){
                        let filePath = response.data.data.profileImageRef  ? response.data.data.profileImageRef.split('/') : [];
                        let fileName = '';

                        if(filePath.length > 0){
                            fileName = filePath[filePath.length - 1];
                        }
                        this.setState({
                            id: response.data.data.agentId,
                            agentId : response.data.data.agentId,
                            fname : response.data.data.firstName,
                            lname : response.data.data.lastName,
                            email : response.data.data.email,
                            phone : "+1" + response.data.data.phone,
                            desc : response.data.data.message ? response.data.data.message : '',
                            npnNumber : response.data.data.npnNumber ? response.data.data.npnNumber : '',
                            addressline1 : response.data.data.addressline1 ? response.data.data.addressline1 : '',
                            addressline2 : response.data.data.addressline2 ? response.data.data.addressline2 : '',
                            city : response.data.data.city ? response.data.data.city : '',
                            zip : response.data.data.zip ? response.data.data.zip : '',
                            imagePath : response.data.data.profileImageRef ? response.data.data.profileImageRef : "",
                            imageName : filePath.length > 0 ? fileName : '',
                            countryCode : "+1",
                            imageErr : '',
                            loaderShow : false,
                            profileModal : true,
                            open:false,
                            anchorEl:null,
                            postobj : response.data.data,
                        }, () => this.checkValidation());
                    }
                });
        }
    }

    handleMenuClick = (event) => {       
        this.setState({open:true,anchorEl:event.currentTarget})
      };

    setUserValue = (value, isValid, parentDetails) => {
        if(parentDetails.name === 'email'){
            if(isValid){
                this.state.email = value;
            } else {
                this.state.email = "";
            }
        }else if(parentDetails.name === 'firstname'){
            if(isValid){
                this.state.fname = value.toUpperCase();
            } else {
                this.state.fname = "";
            }
        } else if(parentDetails.name === 'lastname'){
            if(isValid){
                this.state.lname = value.toUpperCase();
            } else {
                this.state.lname = "";
            }
        } else if(parentDetails.name === 'phone'){
            if(isValid){
                this.state.phone = value;
            } else {
                this.state.phone = "";
            }
        } else if(parentDetails.name === 'desc'){
            if(isValid){
                this.state.desc = value;
            } else {
                this.state.desc = "";
            }
        } else if(parentDetails.name === 'npnNumber'){
            this.state.npnNumber = isValid ? value : "";
        } else if(parentDetails.name === 'addressline1'){
            this.state.addressline1 = isValid ? value : "";
        } else if(parentDetails.name === 'addressline2'){
            this.state.addressline2 = isValid ? value : "";
        } else if(parentDetails.name === 'city'){
            this.state.city = isValid ? value : "";
        } else if(parentDetails.name === 'zip'){
            this.state.zip = isValid ? value : "";
            if (isValid && value && value.length === 5) {
                this.fetchCityForZip(value);
            }
        }

        this.setState({
            refresh : true
        }, () => this.checkValidation());

    }

    checkValidation = () => {
        // A non-empty phone isn't enough - it must be a complete number (matches the
        // same length check used to show the "Enter valid mobile no." message below the field).
        const phoneComplete = this.state.phone !== "" && (this.state.phone.length === 17 || this.state.phone.length === 12);
        if(this.state.fname !== '' && this.state.lname !== '' &&  phoneComplete && this.state.email !== ""
            && this.state.npnNumber !== '' && this.state.addressline1 !== '' && this.state.city !== '' && this.state.zip !== ''
        // && this.state.desc !== ''
        ){
            this.setState({
                agentValid : false
            });
        } else {
            this.setState({
                agentValid : true
            });
        }
    }

    toggleProfileModalMaximize = () => {
        this.setState(prevState => ({ profileModalMaximized: !prevState.profileModalMaximized }));
    }

    fetchLicenses = () => {
        this.setState({ licensesLoading: true });
        axios.get(`${process.env.REACT_APP_BASE_ROOT_URL}/veraagency/api/v1/agent/states?agentId=${this.props.agentId}`)
            .then(response => this.setState({ noStatesToAdd: !(response.data && response.data.data && response.data.data.length) }))
            .catch(() => {});
        axios.get(`${process.env.REACT_APP_BASE_ROOT_URL}/veraagency/api/v1/agent/${this.props.agentId}/licences`)
            .then(response => {
                this.setState({
                    licenses: (response.data && response.data.data) ? response.data.data : [],
                    licensesLoading: false,
                    licensesFetched: true
                });
            })
            .catch(() => {
                this.setState({ licensesLoading: false, licensesFetched: true });
            });
    }

    fetchProducts = () => {
        this.setState({ productsLoading: true });
        axios.get(`${process.env.REACT_APP_BASE_ROOT_URL}/veraagency/api/v1/agent/${this.props.agentId}/program`)
            .then(response => {
                const carriers = (response.data && response.data.data) ? response.data.data : [];
                // Flatten the carrier-grouped response into the assigned (isSelected) products only.
                const products = [];
                carriers.forEach(carrier => {
                    (carrier.programs || []).forEach(program => {
                        if (program.isSelected) {
                            products.push({
                                id: program.id,
                                programName: program.programName,
                                carrierName: program.carrierName,
                                category: program.category,
                                carrierCode: program.carrierCode,
                                productType: program.productType,
                                states: (program.productStates || []).map(s => s.stateCode)
                            });
                        }
                    });
                });
                this.setState({ products, productsLoading: false, productsFetched: true });
            })
            .catch(() => {
                this.setState({ productsLoading: false, productsFetched: true });
            });
    }

    fetchCityForZip = (zip) => {
        axios.get(`${process.env.REACT_APP_BASE_ROOT_URL}/veraagency/api/zipcode/lookup?zipcode=${zip}`)
            .then(response => {
                if (response.data && response.data.city) {
                    this.setState({ city: response.data.city });
                }
            })
            .catch(() => {});
    }

    fetchAddressSuggestions = (query) => {
        if (!query || query.length < 2) {
            this.setState({ addressSuggestions: [], addressSuggestionsOpen: false });
            return;
        }
        axios.get('https://6f6d0qzt06.execute-api.us-east-2.amazonaws.com/v15/lookup', {
            params: {
                'auth-id': 'c1b00808-2977-650e-bee3-16b74a69d1ed',
                'auth-token': 'ULMyoOr0yquyF3mArApW',
                'include_only_zip_codes': this.state.zip || '',
                'include_only_states': '',
                'search': query
            }
        })
            .then(response => {
                this.setState({
                    addressSuggestions: (response.data && response.data.suggestions) ? response.data.suggestions : [],
                    addressSuggestionsOpen: true
                });
            })
            .catch(() => {
                this.setState({ addressSuggestions: [], addressSuggestionsOpen: false });
            });
    }

    handleAddressLine1Change = (event) => {
        const value = event.target.value;
        this.state.addressline1 = value;
        this.setState({ addressline1: value, addressline1Touched: true }, () => this.checkValidation());
        clearTimeout(this.addressDebounceTimer);
        this.addressDebounceTimer = setTimeout(() => this.fetchAddressSuggestions(value), 300);
    }

    selectAddressSuggestion = (suggestion) => {
        this.setState({
            addressline1: suggestion.street_line,
            city: suggestion.city || this.state.city,
            zip: suggestion.zipcode || this.state.zip,
            addressSuggestions: [],
            addressSuggestionsOpen: false
        }, () => this.checkValidation());
    }

    formatLicenseDate = (dateStr) => {
        if (!dateStr) return '';
        const [y, m, d] = dateStr.split('-');
        return new Date(y, m - 1, d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    }

    openLicenseMenu = (event, rowId) => {
        this.setState({ licenseMenuAnchorEl: event.currentTarget, licenseMenuRowId: rowId });
    }

    closeLicenseMenu = () => {
        this.setState({ licenseMenuAnchorEl: null, licenseMenuRowId: null });
    }

    // Mirrors distribution-agency-ui's fetchPrivatePdf (src/pages/AgentsTab/index.jsx):
    // the s3/readData API returns either a raw binary (pdf/image/office doc)
    // or a JSON-wrapped byteArray, depending on the document type.
    fetchPrivateLicenseDoc = async (s3Url) => {
        const encodedS3Url = btoa(s3Url);
        const response = await fetch(`${process.env.REACT_APP_BASE_ROOT_URL}/veraagency/api/v1/s3/readData`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ encodedS3Url })
        });

        if (!response.ok) {
            throw new Error('Failed to fetch document');
        }

        const contentType = response.headers.get('content-type') || '';

        if (contentType.includes('application/pdf') || contentType.startsWith('image/')) {
            return response.blob();
        }

        // Read as raw bytes: decoding binary through text() corrupts the file.
        const buffer = await response.arrayBuffer();
        if (String.fromCharCode(...new Uint8Array(buffer.slice(0, 4))) === '%PDF') {
            return new Blob([buffer], { type: 'application/pdf' });
        }

        let data;
        try {
            data = JSON.parse(new TextDecoder().decode(buffer));
        } catch (e) {
            return new Blob([buffer], { type: contentType || 'application/octet-stream' });
        }
        let bytes;
        if (Array.isArray(data.byteArray)) {
            bytes = new Uint8Array(data.byteArray);
        } else if (typeof data.byteArray === 'string') {
            bytes = Uint8Array.from(atob(data.byteArray), (c) => c.charCodeAt(0));
        } else {
            throw new Error('Invalid document format from API');
        }
        return new Blob([bytes], { type: data.contentType || 'application/pdf' });
    }

    viewLicenseDocument = () => {
        const license = this.state.licenses.find(l => l.id === this.state.licenseMenuRowId);
        this.closeLicenseMenu();
        if (!license) {
            return;
        }
        if (!license.licenceDocUrl) {
            this.setState({ noLicenseDocAlert: true });
            return;
        }
        // Open the tab synchronously on click so the popup blocker doesn't block it after the fetch.
        const docWindow = window.open('', '_blank');
        if (docWindow) {
            // Placeholder so the user doesn't see a blank page while the document downloads.
            docWindow.document.write('<title>Loading document...</title><style>@keyframes s{to{transform:rotate(360deg)}}</style><div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:90vh;font-family:Roboto,Arial,sans-serif;color:#1a2c40"><div style="width:40px;height:40px;border:4px solid #e0e0e0;border-top-color:#1a2c40;border-radius:50%;animation:s 1s linear infinite"></div><p>Loading document, please wait...</p></div>');
            docWindow.document.close();
        }
        this.fetchPrivateLicenseDoc(license.licenceDocUrl)
            .then(blob => {
                const blobUrl = window.URL.createObjectURL(blob);
                if (docWindow) {
                    docWindow.location.href = blobUrl;
                } else {
                    window.open(blobUrl, '_blank');
                }
            })
            .catch(err => {
                if (docWindow) {
                    docWindow.close();
                }
                console.error('View license document failed:', err);
            });
    }

    // Mirrors distribution-agency-ui's Update License dialog (src/pages/AgentsTab/index.jsx)
    // and its updateLicense/uploadLicenseDocument/getAgentStateList API calls.
    openUpdateLicenseModal = () => {
        const license = this.state.licenses.find(l => l.id === this.state.licenseMenuRowId);
        this.closeLicenseMenu();
        if (!license) {
            return;
        }
        this.setState({
            updateLicenseModal: true,
            updateLicenseDocErr: '',
            updateLicenseForm: {
                id: license.id,
                licenceNumber: license.licenceNumber || '',
                stateCode: license.stateCode || '',
                stateName: license.stateName || '',
                effectiveDate: license.effectiveDate || '',
                expiryDate: license.expiryDate || '',
                licenceDocUrl: license.licenceDocUrl || '',
                fileName: license.fileName || ''
            }
        });
        axios.get(`${process.env.REACT_APP_BASE_ROOT_URL}/veraagency/api/v1/agent/states?agentId=${this.props.agentId}&licenceId=${license.id}`)
            .then(response => {
                this.setState({ updateLicenseStates: (response.data && response.data.data) ? response.data.data : [] });
            })
            .catch(() => {});
    }

    openAddLicenseModal = () => {
        this.setState({
            updateLicenseModal: true,
            updateLicenseDocErr: '',
            updateLicenseForm: {
                id: null,
                licenceNumber: '',
                stateCode: '',
                stateName: '',
                effectiveDate: '',
                expiryDate: '',
                licenceDocUrl: '',
                fileName: ''
            }
        });
        axios.get(`${process.env.REACT_APP_BASE_ROOT_URL}/veraagency/api/v1/agent/states?agentId=${this.props.agentId}`)
            .then(response => {
                this.setState({ updateLicenseStates: (response.data && response.data.data) ? response.data.data : [] });
            })
            .catch(() => {});
    }

    closeUpdateLicenseModal = () => {
        this.setState({ updateLicenseModal: false, updateLicenseModalMaximized: false, updateLicenseForm: null, updateLicenseStates: [] });
    }

    handleUpdateLicenseField = (field, value) => {
        this.setState(prevState => ({ updateLicenseForm: { ...prevState.updateLicenseForm, [field]: value } }));
    }

    handleUpdateLicenseStateChange = (event) => {
        const stateCode = event.target.value;
        const state = this.state.updateLicenseStates.find(s => s.stateCode === stateCode);
        this.setState(prevState => ({
            updateLicenseForm: { ...prevState.updateLicenseForm, stateCode, stateName: state ? state.stateName : '' }
        }));
    }

    handleUpdateLicenseDocChange = (event) => {
        const file = event.target.files[0];
        event.target.value = null;
        if (!file) {
            return;
        }
        const validExtensions = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png'];
        const extension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        if (!validExtensions.includes(extension)) {
            this.setState({ updateLicenseDocErr: 'Only PDF, DOC, DOCX, JPG and PNG documents are allowed.' });
            return;
        }
        if (file.size > 25 * 1024 * 1024) {
            this.setState({ updateLicenseDocErr: 'License document must be 25 MB or smaller.' });
            return;
        }
        this.setState({ updateLicenseDocUploading: true, updateLicenseDocErr: '' });
        const formData = new FormData();
        formData.append('file', file);
        axios.post(`${process.env.REACT_APP_BASE_ROOT_URL}/veraagency/api/v1/agent/${this.props.agentId}/licence/upload`, formData)
            .then(response => {
                this.handleUpdateLicenseField('licenceDocUrl', response.data && response.data.data ? response.data.data : '');
                this.handleUpdateLicenseField('fileName', file.name);
                this.setState({ updateLicenseDocUploading: false });
            })
            .catch(() => {
                this.setState({ updateLicenseDocUploading: false, updateLicenseDocErr: 'Failed to upload document.' });
            });
    }

    isUpdateLicenseFormValid = () => {
        const form = this.state.updateLicenseForm;
        if (!form || !form.stateCode || !form.effectiveDate || !form.expiryDate) {
            return false;
        }
        const today = dayjs().format('YYYY-MM-DD');
        if (form.expiryDate < form.effectiveDate || form.expiryDate < today) {
            return false;
        }
        return true;
    }

    saveUpdateLicense = () => {
        const form = this.state.updateLicenseForm;
        this.setState({ updateLicenseSaving: true });
        const payload = {
            stateCode: form.stateCode,
            stateName: form.stateName,
            licenceNumber: form.licenceNumber,
            effectiveDate: form.effectiveDate,
            expiryDate: form.expiryDate,
            licenceDocUrl: form.licenceDocUrl,
            fileName: form.fileName
        };
        const isNew = !form.id;
        const request = isNew
            ? axios.post(`${process.env.REACT_APP_BASE_ROOT_URL}/veraagency/api/v1/agent/${this.props.agentId}/licences`, payload)
            : axios.put(`${process.env.REACT_APP_BASE_ROOT_URL}/veraagency/api/v1/agent/${this.props.agentId}/licences/${form.id}`, payload);
        request
            .then(() => {
                this.setState({ updateLicenseSaving: false });
                this.closeUpdateLicenseModal();
                this.setState({ licensesFetched: false }, () => this.fetchLicenses());
            })
            .catch(() => {
                this.setState({ updateLicenseSaving: false });
            });
    }

    // Returns the expired/rejected licence for a state, unless the state also has a valid licence.
    getStateLicenceIssue = (stateCode) => {
        const stateLicenses = (this.state.licenses || []).filter(l => l.stateCode === stateCode);
        if (stateLicenses.some(l => l.licenceStatus !== 'EXPIRED' && l.licenceStatus !== 'REJECTED')) {
            return null;
        }
        return stateLicenses.find(l => l.licenceStatus === 'REJECTED') || stateLicenses.find(l => l.licenceStatus === 'EXPIRED') || null;
    }

    handleProfileTabChange = (event, newValue) => {
        this.setState({ profileActiveTab: newValue });
        if (newValue === 1 && !this.state.licensesFetched && !this.state.licensesLoading) {
            this.fetchLicenses();
        }
        if (newValue === 2 && !this.state.productsFetched && !this.state.productsLoading) {
            this.fetchProducts();
        }
        if (newValue === 2 && !this.state.licensesFetched && !this.state.licensesLoading) {
            this.fetchLicenses();
        }
    }

    handleFileChange = (event) =>{
        if(event.currentTarget.files.length > 0) {
            const file = event.target.files[0];
            const validFormats = ['image/png', 'image/jpg','image/jpeg'];
            const maxSize = 5 * 1024 * 1024; // 5MB

            // Validate file format
            if (!validFormats.includes(file.type)) {
                this.setState({
                    imageErr: 'Invalid format. Supported formats: JPG, JPEG, PNG',
                });
                event.target.value = null;
                return;
            }

            // Validate file size
            if (file.size > maxSize) {
                this.setState({
                    imageErr: 'File size cannot exceed 5MB',
                });
                event.target.value = null;
                return;
            }

            // Read file and show crop modal
            const reader = new FileReader();
            reader.onload = (e) => {
                this.setState({
                    imageSrc: e.target.result,
                    cropModal: true,
                    selectedFile: file,
                    imageErr: '',
                });
            };
            reader.readAsDataURL(file);
            event.target.value = null;
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.cropModal && !prevState.cropModal && this.state.imageSrc) {
            this.initializeCropBox();
        }
        if (this.state.imagePath !== prevState.imagePath) {
            this.loadPrivateImage('imagePath', 'imagePreviewUrl');
        }
        if (this.state.profileImage !== prevState.profileImage) {
            this.loadPrivateImage('profileImage', 'profileImageUrl');
        }
    }

    // Private S3 images can't be used directly as <img src>; read them via s3/readData.
    loadPrivateImage = (sourceKey, targetKey) => {
        const s3Url = this.state[sourceKey];
        if (this.state[targetKey]) {
            window.URL.revokeObjectURL(this.state[targetKey]);
        }
        // `${targetKey}Loading` drives the small spinner shown while the image is read.
        this.setState({ [targetKey]: null, [targetKey + 'Loading']: !!s3Url });
        if (!s3Url) {
            return;
        }
        this.fetchPrivateLicenseDoc(s3Url)
            .then(blob => {
                if (this.state[sourceKey] === s3Url) {
                    this.setState({ [targetKey]: window.URL.createObjectURL(blob), [targetKey + 'Loading']: false });
                }
            })
            .catch(err => {
                console.error('Read image failed:', err);
                if (this.state[sourceKey] === s3Url) {
                    this.setState({ [targetKey + 'Loading']: false });
                }
            });
    }

    initializeCropBox = () => {
        setTimeout(() => {
            const img = document.getElementById('cropImage');
            if (img && img.complete) {
                const containerWidth = img.clientWidth;
                const containerHeight = img.clientHeight;
                const size = Math.min(containerWidth, containerHeight) * 0.7;
                this.setState({
                    cropBox: {
                        x: (containerWidth - size) / 2,
                        y: (containerHeight - size) / 2,
                        width: size,
                        height: size
                    }
                });
            }
        }, 100);
    }

    handleMouseDown = (e, corner = null) => {
        e.stopPropagation();
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const { cropBox } = this.state;
        
        if (corner) {
            // Resizing from a corner
            this.setState({
                isResizing: true,
                resizeCorner: corner,
                dragStart: { x, y }
            });
        } else if (x >= cropBox.x && x <= cropBox.x + cropBox.width &&
            y >= cropBox.y && y <= cropBox.y + cropBox.height) {
            // Dragging the box
            this.setState({
                isDragging: true,
                dragStart: { x: x - cropBox.x, y: y - cropBox.y }
            });
        }
    }

    handleMouseMove = (e) => {
        if (!this.state.isDragging && !this.state.isResizing) return;
        
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const { dragStart, cropBox, resizeCorner } = this.state;
        
        if (this.state.isResizing) {
            // Handle resizing - maintain square aspect ratio
            let newWidth = cropBox.width;
            let newHeight = cropBox.height;
            let newX = cropBox.x;
            let newY = cropBox.y;
            
            if (resizeCorner === 'se') {
                // Southeast corner
                const deltaX = x - (cropBox.x + cropBox.width);
                const deltaY = y - (cropBox.y + cropBox.height);
                const delta = Math.max(deltaX, deltaY);
                newWidth = Math.max(50, Math.min(cropBox.width + delta, rect.width - cropBox.x, rect.height - cropBox.y));
                newHeight = newWidth;
            } else if (resizeCorner === 'sw') {
                // Southwest corner
                const deltaX = cropBox.x - x;
                const deltaY = y - (cropBox.y + cropBox.height);
                const delta = Math.max(deltaX, deltaY);
                newWidth = Math.max(50, Math.min(cropBox.width + delta, cropBox.x + cropBox.width, rect.height - cropBox.y));
                newHeight = newWidth;
                newX = cropBox.x + cropBox.width - newWidth;
            } else if (resizeCorner === 'ne') {
                // Northeast corner
                const deltaX = x - (cropBox.x + cropBox.width);
                const deltaY = cropBox.y - y;
                const delta = Math.max(deltaX, deltaY);
                newWidth = Math.max(50, Math.min(cropBox.width + delta, rect.width - cropBox.x, cropBox.y + cropBox.height));
                newHeight = newWidth;
                newY = cropBox.y + cropBox.height - newHeight;
            } else if (resizeCorner === 'nw') {
                // Northwest corner
                const deltaX = cropBox.x - x;
                const deltaY = cropBox.y - y;
                const delta = Math.max(deltaX, deltaY);
                newWidth = Math.max(50, Math.min(cropBox.width + delta, cropBox.x + cropBox.width, cropBox.y + cropBox.height));
                newHeight = newWidth;
                newX = cropBox.x + cropBox.width - newWidth;
                newY = cropBox.y + cropBox.height - newHeight;
            }
            
            this.setState({
                cropBox: { x: newX, y: newY, width: newWidth, height: newHeight }
            });
        } else if (this.state.isDragging) {
            // Handle dragging
            let newX = x - dragStart.x;
            let newY = y - dragStart.y;
            
            // Boundary checks
            newX = Math.max(0, Math.min(newX, rect.width - cropBox.width));
            newY = Math.max(0, Math.min(newY, rect.height - cropBox.height));
            
            this.setState({
                cropBox: { ...cropBox, x: newX, y: newY }
            });
        }
    }

    handleMouseUp = () => {
        this.setState({ isDragging: false, isResizing: false, resizeCorner: null });
    }

    getCroppedImage = () => {
        const canvas = document.createElement('canvas');
        const img = document.getElementById('cropImage');
        const ctx = canvas.getContext('2d');
        
        const scaleX = img.naturalWidth / img.clientWidth;
        const scaleY = img.naturalHeight / img.clientHeight;
        
        canvas.width = this.state.cropBox.width * scaleX;
        canvas.height = this.state.cropBox.height * scaleY;
        
        ctx.drawImage(
            img,
            this.state.cropBox.x * scaleX,
            this.state.cropBox.y * scaleY,
            this.state.cropBox.width * scaleX,
            this.state.cropBox.height * scaleY,
            0,
            0,
            canvas.width,
            canvas.height
        );
        
        return new Promise((resolve) => {
            canvas.toBlob((blob) => {
                resolve(blob);
            }, 'image/jpeg', 0.95);
        });
    }

    handleCropSave = async () => {
        try {
            this.setState({ loaderShow: true, cropModal: false });

            const croppedBlob = await this.getCroppedImage();

            if (!croppedBlob) {
                this.setState({ loaderShow: false, imageErr: 'Crop failed. Please try again.' });
                return;
            }

            const croppedFile = new File([croppedBlob], this.state.selectedFile.name, {
                type: 'image/jpeg',
            });

            let bodyFormData = new FormData();
            bodyFormData.append('file', croppedFile);
            this.state.imageName = this.state.selectedFile.name;

            axios(configurations.baseUrl + 'uploadImage', {
                method: 'post',
                data: bodyFormData,
                headers: {'Content-Type': 'multipart/form-data' }
            }).then(response =>{
                if(response.data.code === 200){
                    this.setState({
                        imagePath : response.data.response,
                        loaderShow : false,
                        imageSrc: null,
                        croppedImage: null,
                    },() => this.checkValidation());
                }
            }).catch(error => {
                this.setState({
                    loaderShow: false,
                    imageErr: 'Upload failed. Please try again.',
                });
            });

        } catch (e) {
            console.error(e);
            this.setState({
                loaderShow: false,
                imageErr: 'Processing failed. Please try again.',
            });
        }
    }

    handleCropCancel = () => {
        this.setState({
            cropModal: false,
            imageSrc: null,
            croppedImage: null,
            selectedFile: null,
            cropBox: { x: 50, y: 50, width: 200, height: 200 },
            isDragging: false,
            isResizing: false,
            resizeCorner: null,
        });
    }

    handleRemoveProfilePic = () => {
        this.setState({ imagePath: '', imageName: '', imageSrc: null });
    }

    updateAgentAndView=()=>{
        this.updateAgent();
        let data = JSON.parse(sessionStorage.getItem("USER_DATA"))
        let url = configurations.AGENT_BASE_URL + data.clientName + "/"+ this.props.agentId
        if(url !== ''){
         
             document.execCommand("copy",);
            window.open(url, '_blank');
         }
    }

    // Password tab: Cognito change password for the signed-in user (Cognito
    // itself verifies the current password). First-login NEW_PASSWORD_REQUIRED
    // is still handled by FirstTimePasswordChange at sign-in.
    changePassword = async () => {
        this.setState({ loaderShow: true, feedbackMsg: null });
        try {
            const user = await Auth.currentAuthenticatedUser();
            await Auth.changePassword(user, this.state.currentPassword, this.state.newPassword);
            this.captureEvents(this.props.agentId, sessionStorage.getItem('email') || this.state.email, "RESET_PASSWORD");
            this.setState({
                loaderShow: false,
                currentPassword: '',
                newPassword: '',
                confirmPassword: '',
                newPasswordValid: false,
                feedbackMsg: { severity: 'success', text: 'Your password has been successfully changed.', closeProfile: true }
            });
        } catch (err) {
            console.log(err);
            this.setState({
                loaderShow: false,
                feedbackMsg: { severity: 'error', text: err.code === 'NotAuthorizedException' ? 'Current password is incorrect.' : (err.message || 'Unable to change password. Please try again.') }
            });
        }
    }

    closeFeedback = () => {
        const closeProfile = this.state.feedbackMsg && this.state.feedbackMsg.closeProfile;
        this.setState({ feedbackMsg: null });
        if (closeProfile) {
            this.setState({ profileModal: false }, () => this.clearData());
        }
    }

    updateAgent = () =>{
        this.setState({
            loaderShow : true
        });
        let newPhone = this.state.phone.replace(/[^a-zA-Z0-9]/g, '');

        let obj = {
            "firstName" : this.state.fname,
            "lastName": this.state.lname,
            "description": this.state.desc,
            "email":this.state.email,
            "phone": this.state.countryCode + newPhone.substr(1),
            image : this.state.imagePath ? this.state.imagePath : ""
        }

        let object = JSON.parse(JSON.stringify(this.state.postobj));
        object.firstName = this.state.fname;
        object.lastName = this.state.lname;
        object.phone = this.state.phone.replaceAll("+1", "").replace(/[^a-zA-Z0-9+]/g, '');
        object.message = this.state.desc || null;
        object.npnNumber = this.state.npnNumber || null;
        object.addressline1 = this.state.addressline1 || null;
        object.addressline2 = this.state.addressline2 || null;
        object.city = this.state.city || null;
        object.zip = this.state.zip || null;
        object.profileImageRef = this.state.imagePath ? this.state.imagePath : "";
        let url= `${process.env.REACT_APP_BASE_ROOT_URL}/veraagency/api/v1/agent/${this.props.agentId}`;

        axios.put(url, object)
            .then(response => {
                if(response.data){
                    // Profile Settings closes only once this toast is dismissed (closeFeedback).
                    this.setState({  
                        loaderShow : false,
                        feedbackMsg : { severity: 'success', text: 'Profile updated successfully', closeProfile: true }
                    });
                    this.getClientProfile();
                }

            })
            .catch(() => {
                this.setState({ loaderShow : false, feedbackMsg : { severity: 'error', text: 'Unable to update profile. Please try again.' } });
            })
    }

    clearData = () =>{
        this.setState({
            addressline1Touched: false,
            fname:'',
            lname:'',
            email:'',
            phone:'',
            countryCode : '',
            desc : '',
            npnNumber : '',
            addressline1 : '',
            addressline2 : '',
            city : '',
            zip : '',
            imageName : '',
            imageErr : '',
            imageSrc : null,
            profileModalMaximized : false,
            profileActiveTab : 0,
            licenses : [],
            licensesLoading : false,
            licensesFetched : false,
            noStatesToAdd : false,
            licenseMenuAnchorEl : null,
            licenseMenuRowId : null,
            updateLicenseModal : false,
            updateLicenseModalMaximized : false,
            updateLicenseForm : null,
            updateLicenseStates : [],
            updateLicenseSaving : false,
            updateLicenseDocUploading : false,
            updateLicenseDocErr : '',
            products : [],
            productsLoading : false,
            productsFetched : false,
            addressSuggestions : [],
            addressSuggestionsOpen : false,
            currentPassword : '',
            newPassword : '',
            confirmPassword : '',
            newPasswordValid : false,
            showCurrentPassword : false,
            showNewPassword : false,
            showConfirmPassword : false
        });
    }
      
    SwitchClient=(event) =>{
        let channel=this.state.switchArray.filter(result => result.clientName==event);
        localStorage.setItem("channelName", event)
        if(channel.length>0){
        let obj={
            "custom:agentid": this.props.agentId,
            "given_name": "Netwell",
            "custom:associationId": channel[0].associationId,
            "custom:ChannelId": channel[0].clientId,
            "name": channel[0].firstName + " " + channel[0].lastName,
            "family_name": channel[0].lastName,
            "email": localStorage.getItem("email")
        }
        localStorage.setItem("SwitchAccount", JSON.stringify(obj))
        localStorage.setItem("brokerID", channel[0].brokerId)
        window.location.href = '/'
    }else{
        localStorage.removeItem("SwitchAccount")
        localStorage.removeItem("brokerID")
        window.location.href = '/'
    }
    }
    getModeList = (topbarData) => {
        var valuesData = topbarData;
        if(valuesData){
            valuesData.employer = valuesData.emplopyer || null;  
                delete valuesData.emplopyer;
            }
            const transformData = {};
    
            if (valuesData && typeof valuesData === 'object') {
                for (const [label, values] of Object.entries(valuesData)) {
                  transformData[label] = {};
                  if (values && typeof values === 'object') {
                    for (const [key, value] of Object.entries(values)) {
                      transformData[label][key.toUpperCase()] = value;
                    }
                  }
                }
              }
    
            const labelArray = Object.keys(transformData).map(key => ({
             label: "Work with " + key.charAt(0).toUpperCase() + key.slice(1) + "s"
            }));
            return labelArray;
    }

    getClientProfile = () => {
        const url = `${configurations.baseUrl}getAgentById/`+ sessionStorage.getItem('parentBrokerId');
        axios.get(url)
            .then(response => {
                if (response.data && response.data.response && response.data.response.image) {
                    this.setState({ profileImage: response.data.response.image });
                } else {
                    this.setState({ profileImage: null });
                }
            })
            .catch(error => {
                console.error('Error fetching agent profile:', error);
                this.setState({ profileImage: null });
            });
    }

    render() {
        const params = new URLSearchParams(window.location.search);
        const empid = params.get("empid");

        const labelArray = this.getModeList(this.state.topbarData);
        const options=["Profile","Sign Out"]
        console.log('Current route:', this.props.location.pathname);
        let currentScreen = '';
        this.state.isLogged = sessionStorage.getItem('isLogged');

        if (this.state.isLogged === 'true' || this.state.isLogged === true) {
            currentScreen = <div style={styles.LoginWrp}>
                <div style={styles.HeaderWrp}>
                    <Grid xs={6} style={styles.HeaderRightWrp} item={true}>
                        <span style={styles.LoginRight}>Member Enrollment</span>
                    </Grid>
                    <Grid xs={6} style={styles.HeaderLeftWrp} item={true}>

                        <span style={styles.LoginLeft} onClick={this.logoutHandler}>LOGOUT</span>
                    </Grid>
                </div>
            </div>
        } else {
            currentScreen = <div  >
                     <AppBar title="Agent Portal" position='fixed' style={{backgroundColor:'#fff',marginBottom: this.props.bottomMargin, display : '-webkit-inline-box', zIndex: 100, boxShadow: 'none'}}>
                         <Toolbar style={{width : '50%', padding : '5px'}}>
                         {(empid && process.env.REACT_APP_PORTAL != 'employer') ? <IconButton color="inherit" aria-label="Menu" style={{marginTop:'6px',marginRight:'6px', cursor : 'pointer'}} onClick={() => {window.location.replace('/manage-employers')}} >
                                     <ArrowBackIcon style={{color: "#8283be"}}/>
                                 </IconButton> : <div style={{paddingRight: 30}}/>}
                                     <img src={require("../../../Assets/Images/VERABenefitsLogo.png")} height={"25px"}/>
                         </Toolbar>
                         <Toolbar style={{width : '50%'}}>
                             <div className="spacer"/>
                                 {/* {this.state.userName} */}
                                 <span onClick={this.handleMenuClick} style={{ display: 'inline-flex', cursor: 'pointer' }}>
                                 {this.state.profileImageUrlLoading ? (
                                                <CircularProgress size={24} style={{ margin: '10px 18px', color: '#8283be' }} />
                                            ) : this.state.profileImageUrl ? (
                                                <img
                                                     src={this.state.profileImageUrl}
                                                     alt="Profile"
                                                     style={{
                                                          height: '45px',
                                                          width: '45px',
                                                          cursor: 'pointer',
                                                          borderRadius: '50%',
                                                          objectFit: 'cover',
                                                          display: 'block',
                                                          border: '2px solid #e0e0e0',
                                                          background: '#fff',
                                                          margin: '0 8px'
                                                     }}
                                                />
                                            ) : (
                                                <AccountCircle style={{padding:'0 0.5rem',height:'45px',width:'45px',cursor:'pointer', color: "#8283be"}}/>
                                            )}
                                            </span>

                                 <Menu keepMounted open={this.state.open} anchorEl={this.state.anchorEl} onClose={this.handleClose}
                                     // style={{left: '85%', top: '-55%'}}
                                       getContentAnchorEl={null}
                                       anchorOrigin={{
                                           vertical: 110,
                                           horizontal: 60,
                                       }}
                                       transformOrigin={{
                                           vertical: 80,
                                           horizontal: "right",
                                       }}>
                                     {options.map((op,i)=>{
                                         return <MenuItem key={i} value={op} onClick={this.handleOption.bind(this, op)}>
                                             {op}
                                         </MenuItem>
                                     })}

                                 </Menu>
                         </Toolbar>
                     </AppBar>
                     
                     {!this.props.hideResource && <div style={{display: "none", marginTop: this.props.location.pathname === "/" ? 0 : 65, right: this.state.rightBar ? 552: 0}} class="web_orange_tag" onClick={() => this.setState({rightBar:true})}><div class="web_patch_text">Resources</div></div>}
                     <SwipeableDrawer
                            anchor={"right"}
                            open={this.state.rightBar}
                            style={{zIndex: 99}}
                            onClose={() => this.setState({rightBar:false})}
                            onOpen={() => this.setState({rightBar:true})}
                        
                        >
                            <div style={{width: 552, paddingTop: 100, height: "100%", backgroundColor: "#dfe3e9", overflowX: 'hidden'}}>
                               <AccordonCommon 
                               clientId={this.props.clientId} 
                               clientName={this.props.clientName} 
                               agentId={this.props.agentId} 
                               disable={this.props.location.pathname === "/"} 
                               forHouseholds={this.props.location.pathname === "/manage-prospects"}
                               empid={this.state.empid || ""} 
                               empName={(this.state.countData && this.state.countData.companyName) ? this.state.countData.companyName : ''}
                               />
                            </div>
                    </SwipeableDrawer>
                    
            </div>
        }


        return (
            <div>
                {
                    this.state.loaderShow ? <Loader></Loader> : ''
                }
                {
                    currentScreen
                }

                {/*=================================== Profile Model ======================================*/}
                <Modal size={this.state.profileModalMaximized ? null : "xl"} show={this.state.profileModal} onHide={() => this.setState({profileModal:false, loaderShow : false}, () => this.clearData())} centered={!this.state.profileModalMaximized} backdrop="static" dialogClassName={`profile-settings-modal ${this.state.profileModalMaximized ? "modal-fullscreen" : ""}`}>
                    <Modal.Header style={styles.modal_header}>
                        <Modal.Title>Profile Settings</Modal.Title>
                        <div style={{ marginLeft: 'auto', display: 'flex' }}>
                            <IconButton size="small" aria-label={this.state.profileModalMaximized ? "exit fullscreen" : "fullscreen"} onClick={this.toggleProfileModalMaximize}>
                                {this.state.profileModalMaximized ? <FullscreenExitIcon /> : <FullscreenIcon />}
                            </IconButton>
                            <IconButton size="small" aria-label="close" onClick={() => this.setState({profileModal:false, loaderShow : false}, () => this.clearData())}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                    </Modal.Header>
                    <Modal.Body  style={{  width : '100%' }}>
                        {
                            this.state.loaderShow ? <Loader></Loader> : ''
                        }

                        <Tabs className="profile-tabs" value={this.state.profileActiveTab} onChange={this.handleProfileTabChange} variant="fullWidth">
                            <Tab label="PROFILE" />
                            <Tab label="LICENSES" />
                            <Tab label="PRODUCTS" />
                            <Tab label="PASSWORD" />
                        </Tabs>

                        {this.state.profileActiveTab === 1 && !this.state.licensesLoading && (
                            <table className="license-table license-table-with-action license-table-head-fixed">
                                <colgroup>
                                    <col style={{width: '20%'}} />
                                    <col style={{width: '14%'}} />
                                    <col style={{width: '18%'}} />
                                    <col style={{width: '18%'}} />
                                    <col style={{width: '16%'}} />
                                    <col style={{width: '14%'}} />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>License Number</th>
                                        <th>State of License</th>
                                        <th>License Effective Date</th>
                                        <th>License Expiry Date</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                            </table>
                        )}

                        {this.state.profileActiveTab === 2 && !this.state.productsLoading && (
                            <table className="license-table license-table-head-fixed">
                                <colgroup>
                                    <col style={{width: '30%'}} />
                                    <col style={{width: '22%'}} />
                                    <col style={{width: '24%'}} />
                                    <col style={{width: '24%'}} />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>Products Assigned</th>
                                        <th>Carrier</th>
                                        <th>Category</th>
                                        <th>States</th>
                                    </tr>
                                </thead>
                            </table>
                        )}

                        <div className="profile-body-content">
                        <div className={`profile-tab-scroll-area${this.state.profileActiveTab === 0 ? ' profile-tab-no-scrollbar' : ''}${this.state.profileActiveTab === 3 ? ' password-tab-scroll-area' : ''}${(this.state.profileActiveTab === 1 || this.state.profileActiveTab === 2) ? ' license-tab-scroll-area' : ''}${((this.state.profileActiveTab === 1 && !this.state.licensesLoading) || (this.state.profileActiveTab === 2 && !this.state.productsLoading)) ? ' with-table-head' : ''}`}>

                        {this.state.profileActiveTab === 3 && (
                            <div className="profile-fields-padded" style={{ paddingTop: 20 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        label="Current Password"
                                        required
                                        type={this.state.showCurrentPassword ? 'text' : 'password'}
                                        variant="filled"
                                        fullWidth
                                        value={this.state.currentPassword}
                                        onChange={(e) => this.setState({ currentPassword: e.target.value })}
                                        InputProps={{
                                            endAdornment: (
                                                <IconButton size="small" onClick={() => this.setState(prevState => ({ showCurrentPassword: !prevState.showCurrentPassword }))}>
                                                    {this.state.showCurrentPassword ? <VisibilityOff style={{ fontSize: 18 }} /> : <Visibility style={{ fontSize: 18 }} />}
                                                </IconButton>
                                            )
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} style={{ position: 'relative' }}>
                                    <TextField
                                        label="New Password"
                                        required
                                        type={this.state.showNewPassword ? 'text' : 'password'}
                                        variant="filled"
                                        fullWidth
                                        value={this.state.newPassword}
                                        onChange={(e) => this.setState({ newPassword: e.target.value })}
                                        InputProps={{
                                            endAdornment: (
                                                <IconButton size="small" onClick={() => this.setState(prevState => ({ showNewPassword: !prevState.showNewPassword }))}>
                                                    {this.state.showNewPassword ? <VisibilityOff style={{ fontSize: 18 }} /> : <Visibility style={{ fontSize: 18 }} />}
                                                </IconButton>
                                            )
                                        }}
                                    />
                                    <PasswordValidations password={this.state.newPassword} allPassed={(valid) => this.state.newPasswordValid !== valid && this.setState({ newPasswordValid: valid })} />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        label="Re-Enter New Password"
                                        required
                                        type={this.state.showConfirmPassword ? 'text' : 'password'}
                                        variant="filled"
                                        fullWidth
                                        value={this.state.confirmPassword}
                                        onChange={(e) => this.setState({ confirmPassword: e.target.value })}
                                        error={Boolean(this.state.confirmPassword) && this.state.confirmPassword !== this.state.newPassword}
                                        helperText={(this.state.confirmPassword && this.state.confirmPassword !== this.state.newPassword) ? 'Please enter same password.' : ''}
                                        InputProps={{
                                            endAdornment: (
                                                <IconButton size="small" onClick={() => this.setState(prevState => ({ showConfirmPassword: !prevState.showConfirmPassword }))}>
                                                    {this.state.showConfirmPassword ? <VisibilityOff style={{ fontSize: 18 }} /> : <Visibility style={{ fontSize: 18 }} />}
                                                </IconButton>
                                            )
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <p className="modal-footer-note" style={{ margin: 0 }}>Fields marked with <span style={{color:'red'}}>*</span> are required.</p>
                                </Grid>
                            </Grid>
                            </div>
                        )}

                        {this.state.profileActiveTab === 2 && (
                            this.state.productsLoading ? <Loader></Loader> : (
                            <table className="license-table products-table">
                                <colgroup>
                                    <col style={{width: '30%'}} />
                                    <col style={{width: '22%'}} />
                                    <col style={{width: '24%'}} />
                                    <col style={{width: '24%'}} />
                                </colgroup>
                                <tbody>
                                    {this.state.products.map((p) => (
                                        <tr key={p.id}>
                                            <td>{p.programName}</td>
                                            <td>{p.carrierCode}</td>
                                            <td>{p.productType}</td>
                                            <td>{p.states.length > 0 ? p.states.map((st, i) => {
                                                const lic = this.getStateLicenceIssue(st);
                                                return (
                                                    <React.Fragment key={st}>
                                                        {i > 0 && ', '}
                                                        {lic ? (
                                                            <span style={{ color: '#f44336' }}>
                                                                {st}
                                                                <Tooltip title={lic.licenceStatus === 'EXPIRED' ? `Licence expired on ${lic.expiryDate}` : ((lic.rejectReason || '').trim() || 'Licence rejected')} placement="top" arrow>
                                                                    <InfoOutlinedIcon style={{ fontSize: 16, marginLeft: 4, verticalAlign: 'middle', cursor: 'pointer', color: '#f44336' }} />
                                                                </Tooltip>
                                                            </span>
                                                        ) : st}
                                                    </React.Fragment>
                                                );
                                            }) : '-'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            )
                        )}

                        {this.state.profileActiveTab === 1 && (
                            this.state.licensesLoading ? <Loader></Loader> : (
                            <React.Fragment>
                            <table className="license-table license-table-with-action products-table">
                                <colgroup>
                                    <col style={{width: '20%'}} />
                                    <col style={{width: '14%'}} />
                                    <col style={{width: '18%'}} />
                                    <col style={{width: '18%'}} />
                                    <col style={{width: '16%'}} />
                                    <col style={{width: '14%'}} />
                                </colgroup>
                                <tbody>
                                    {this.state.licenses.map((lic) => {
                                        const isExpired = lic.licenceStatus === 'EXPIRED';
                                        const isRejected = lic.licenceStatus === 'REJECTED';
                                        const isActive = lic.licenceStatus === 'ACTIVE';
                                        return (
                                            <tr key={lic.id} className={isExpired ? 'license-row-expired' : ''}>
                                                <td>{lic.licenceNumber}</td>
                                                <td style={isRejected ? { color: '#f44336' } : undefined}>
                                                    {lic.stateCode}
                                                    {lic.isResident && (
                                                        <span style={{ marginLeft: 8, padding: '2px 6px', borderRadius: 4, backgroundColor: '#4a90d9', color: '#fff', fontSize: 11, fontWeight: 500, letterSpacing: '0.5px', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>
                                                            RESIDENT
                                                        </span>
                                                    )}
                                                    {(isExpired || isRejected) && (
                                                        <Tooltip title={isExpired ? `Licence expired on ${lic.expiryDate}` : ((lic.rejectReason || '').trim() || 'Licence rejected')} placement="top" arrow>
                                                            <InfoOutlinedIcon style={{ fontSize: 16, marginLeft: 4, verticalAlign: 'middle', cursor: 'pointer', color: '#f44336' }} />
                                                        </Tooltip>
                                                    )}
                                                </td>
                                                <td>{this.formatLicenseDate(lic.effectiveDate)}</td>
                                                <td>{this.formatLicenseDate(lic.expiryDate)}</td>
                                                <td>
                                                    <span className={`license-status-badge ${isActive ? 'license-status-active' : (isExpired || isRejected) ? 'license-status-expired' : 'license-status-pending'}`}>
                                                        {lic.licenceStatus}
                                                    </span>
                                                </td>
                                                <td>
                                                    <IconButton size="small" onClick={(e) => this.openLicenseMenu(e, lic.id)}>
                                                        <MoreVertIcon style={{ color: '#1a2c40' }} fontSize="small" />
                                                    </IconButton>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            <Menu anchorEl={this.state.licenseMenuAnchorEl} open={Boolean(this.state.licenseMenuAnchorEl)} onClose={this.closeLicenseMenu}>
                                <MenuItem onClick={this.openUpdateLicenseModal}>Update License</MenuItem>
                                <MenuItem onClick={this.viewLicenseDocument}>View License Document</MenuItem>
                            </Menu>
                            <MuiDialog open={!!this.state.noLicenseDocAlert} onClose={() => this.setState({ noLicenseDocAlert: false })} maxWidth="xs" fullWidth PaperProps={{ sx: { backgroundColor: 'transparent', boxShadow: 'none' } }}>
                                <MuiAlert
                                    severity="warning"
                                    icon={<InfoOutlinedIcon style={{ color: '#fff' }} />}
                                    action={
                                        <>
                                            {this.state.noLicenseDocAlert && <FeedbackCountdown onDone={() => this.setState({ noLicenseDocAlert: false })} />}
                                            <IconButton size="small" onClick={() => this.setState({ noLicenseDocAlert: false })} style={{ position: 'absolute', top: 2, right: 2 }}><CloseIcon fontSize="small" style={{ color: '#4d4d4d' }} /></IconButton>
                                        </>
                                    }
                                    sx={{ position: 'relative', alignItems: 'center', backgroundColor: '#ffa716', color: '#fff', borderRadius: '8px', fontWeight: 500 }}
                                >
                                    No document available for this license.
                                </MuiAlert>
                            </MuiDialog>
                            </React.Fragment>
                            )
                        )}

                        {this.state.profileActiveTab === 0 && <React.Fragment>
                        <div className="profile-fields-padded">
                        <Grid container spacing={2}>
                        <Grid item xs={12} sm={8}>
                        <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} >
                        <Sample setChild={() => {}} showHelper={false} reqFlag={false} name={'agentId'} label={'Agent ID'} value={this.state.agentId} disable={true} style={customStyle.textFieldWrpAgent} length={25}  fieldType={'text'} errMsg={''} parentDetails={{name:'agentId'}}></Sample>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                        <Sample setChild={this.setUserValue.bind(this)} showHelper={false} reqFlag={true} name={'npnNumber'} label={'NPN Number'} value={this.state.npnNumber} disable={false} style={customStyle.textFieldWrpAgent} length={9}  fieldType={'num'} errMsg={'NPN number must be a 8 or 9 digits numeric value'} helperMsg={'NPN number required'}  parentDetails={{name:'npnNumber'}}></Sample>
                        </Grid>
                        <Grid item xs={12} sm={6} >
                        <SampleName setChild={this.setUserValue.bind(this)} reqFlag={true} name={'firstname'} label={'First Name'} value={this.state.fname} disable={false} style={customStyle.textFieldWrpAgent} length={25}  fieldType={'fullName'} errMsg={'Enter valid first name'} helperMsg={'First name required'}  parentDetails={{name:'firstname'}}></SampleName>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                        <SampleName setChild={this.setUserValue.bind(this)} reqFlag={true} name={'lastname'} label={'Last Name'} value={this.state.lname} disable={false} style={customStyle.textFieldWrpAgent} length={25}  fieldType={'fullName'} errMsg={'Enter valid last name'} helperMsg={'Last name required'}  parentDetails={{name:'lastname'}}></SampleName>
                        </Grid>
                        <Grid item xs={12} sm={6} >
                        <Sample setChild={this.setUserValue.bind(this)} showHelper={true} reqFlag={false} name={'email'} label={'Email Address'} value={this.state.email} disable={true} style={customStyle.textFieldWrpAgent} length={50}  fieldType={'email'} errMsg={'Enter valid email Id'} helperMsgText={'Need to update this? Please contact Agent Support.'}  parentDetails={{name:'email'}}></Sample>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div>
                                <MuiPhoneNumber
                                    name={"phone"}
                                    required
                                    id="filled-required"
                                    label={"Phone"}
                                    data-cy="user-phone"
                                    variant="filled"
                                    defaultCountry={"us"}
                                    onlyCountries={["us"]}
                                    autoComplete='off'
                                    value={this.state.phone}
                                    onChange={(e) => this.setUserValue(e, true, { name: 'phone' })}
                                    style={customStyle.textFieldWrpAgent}
                                />
                                {(!this.state.phone || this.state.phone.length === 17 || this.state.phone.length === 12) ? null : <p class="MuiFormHelperText-root MuiFormHelperText-contained Mui-required mobileErr">Enter valid mobile no.</p>}
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6} style={{ position: 'relative' }}>
                            <TextField
                                label="Address Line 1"
                                required
                                variant="filled"
                                fullWidth
                                autoComplete="off"
                                style={customStyle.textFieldWrpAgent}
                                inputProps={{ maxLength: 100 }}
                                value={this.state.addressline1}
                                error={this.state.addressline1Touched && !String(this.state.addressline1 || '').trim()}
                                helperText={this.state.addressline1Touched && !String(this.state.addressline1 || '').trim() ? 'Address required' : ''}
                                onChange={this.handleAddressLine1Change}
                                onFocus={() => { if (this.state.addressSuggestions.length > 0) this.setState({ addressSuggestionsOpen: true }); }}
                                onBlur={() => setTimeout(() => this.setState({ addressSuggestionsOpen: false, addressline1Touched: true }), 150)}
                            />
                            {this.state.addressSuggestionsOpen && this.state.addressSuggestions.length > 0 && (
                                <div className="address-suggestions-dropdown">
                                    {this.state.addressSuggestions.map((s, idx) => (
                                        <div key={idx} className="address-suggestion-item" onMouseDown={() => this.selectAddressSuggestion(s)}>
                                            <div className="address-suggestion-primary">{s.street_line}</div>
                                            <div className="address-suggestion-secondary">{s.city}, {s.state} {s.zipcode}</div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                        <Sample setChild={this.setUserValue.bind(this)} showHelper={false} reqFlag={false} name={'addressline2'} label={'Address Line 2'} value={this.state.addressline2} disable={false} style={customStyle.textFieldWrpAgent} length={100}  fieldType={'street'} errMsg={'Enter valid address'} helperMsg={''}  parentDetails={{name:'addressline2'}}></Sample>
                        </Grid>
                        <Grid item xs={12} sm={6} >
                        <Sample setChild={this.setUserValue.bind(this)} showHelper={false} reqFlag={true} name={'city'} label={'City'} value={this.state.city} disable={false} style={customStyle.textFieldWrpAgent} length={50}  fieldType={'city'} errMsg={'Enter valid city'} helperMsg={'City required'}  parentDetails={{name:'city'}}></Sample>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                        <Sample setChild={this.setUserValue.bind(this)} showHelper={false} reqFlag={true} name={'zip'} label={'Zip'} value={this.state.zip} disable={false} style={customStyle.textFieldWrpAgent} length={5}  fieldType={'zip'} errMsg={'Enter valid zip'} helperMsg={'Zipcode required'}  parentDetails={{name:'zip'}}></Sample>
                        </Grid>
                        </Grid>
                        </Grid>

                        <Grid item xs={12} sm={4} style={{ textAlign: 'center' }}>
                            <div style={{ width: 250, height: 250, flexGrow: 0, borderRadius: '12px', backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto', overflow: 'hidden', border: this.state.imageSrc ? 'none' : '1px solid #e0e0e0' }}>
                                {!this.state.imageSrc && this.state.imagePreviewUrlLoading ? (
                                    <CircularProgress size={32} style={{ color: '#1a2c40' }} />
                                ) : this.state.imageSrc || this.state.imagePreviewUrl ? (
                                    <img src={this.state.imageSrc || this.state.imagePreviewUrl} alt="Profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                ) : (
                                    <AccountCircle style={{ fontSize: 190, color: '#bbb' }} />
                                )}
                            </div>
                            <div style={{ marginTop: 16 }}>
                                <input accept="image/png,image/jpg,image/jpeg" style={{display : 'none'}} id="icon-button-file" type="file" onChange={this.handleFileChange.bind(this)} />
                                <label htmlFor="icon-button-file">
                                    <NextButton component="span" style={{ height: '36px', width: 'auto', padding: '0 16px' }}>
                                        <PhotoCamera style={{ fontSize: 18, marginRight: 6 }} />Upload Photo
                                    </NextButton>
                                </label>
                                {this.state.imageName && (
                                    <Tooltip title="Reset profile picture">
                                        <CustomButton style={{ height: '36px', marginLeft: 8 }} onClick={this.handleRemoveProfilePic}>
                                            <ClearIcon style={{ fontSize: 18, marginRight: 6 }} />Reset
                                        </CustomButton>
                                    </Tooltip>
                                )}
                            </div>
                            <div style={{ marginTop: 8, fontSize: '12px', color: '#666' }}>JPG, JPEG or PNG Allowed; Max size 5MB</div>
                            {this.state.imageErr && <div style={{ marginTop: 4, color : '#f44336', fontSize: '12px' }}>{this.state.imageErr}</div>}
                        </Grid>
                        </Grid>
                        </div>
                        </React.Fragment>}

                        </div>
                        <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                        className="profile-footer-row"
                        style={{marginTop: 16}}
                        >
                            <Grid item>
                        {this.state.profileActiveTab === 0 && (
                            <p className="modal-footer-note" style={{margin: '0 0 0 490px'}}>Fields marked with  <span style={{color:'red'}}>*</span> are required.</p>
                        )}
                        {this.state.profileActiveTab === 1 && (
                            <div className="add-license-btn" onClick={this.state.noStatesToAdd ? undefined : this.openAddLicenseModal} style={this.state.noStatesToAdd ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}>
                                <span className="add-license-icon"><AddIcon fontSize="small" /></span>
                                Add Another License
                            </div>
                        )}
                        </Grid>
                            <Grid item>
                        <Grid container spacing={2}>
                            <Grid item>
                        <CustomButton style={{height : '40px'}} onClick={() => this.setState({profileModal:false, loaderShow : false}, () => this.clearData())}>CANCEL</CustomButton>
                        </Grid>
                            <Grid item>
                        <NextButton style={{margin: '0', width: '95px', height: '40px'}} disabled={this.state.agentValid || this.state.profileActiveTab === 2 || (this.state.profileActiveTab === 3 && (!this.state.currentPassword || !this.state.newPasswordValid || this.state.confirmPassword !== this.state.newPassword))} onClick={() => this.state.profileActiveTab === 3 ? this.changePassword() : this.updateAgent()}>UPDATE</NextButton>
                        </Grid>
                        </Grid>
                        </Grid>
                        </Grid>
                        </div>

                    </Modal.Body>
                </Modal>
                {/* Success/error toast for Profile update and Password change (same look as distribution-agency-ui's FeedbackDialog). */}
                <MuiDialog open={!!this.state.feedbackMsg} onClose={this.closeFeedback} maxWidth="xs" fullWidth PaperProps={{ sx: { backgroundColor: 'transparent', boxShadow: 'none' } }}>
                    {this.state.feedbackMsg && (
                        <MuiAlert
                            severity={this.state.feedbackMsg.severity}
                            icon={this.state.feedbackMsg.severity === 'success' ? <CheckCircleOutlineOutlinedIcon style={{ color: '#fff' }} /> : <ErrorOutlineOutlinedIcon style={{ color: '#fff' }} />}
                            action={
                                <>
                                    <FeedbackCountdown onDone={this.closeFeedback} />
                                    <IconButton size="small" onClick={this.closeFeedback} style={{ position: 'absolute', top: 2, right: 2 }}><CloseIcon fontSize="small" style={{ color: '#4d4d4d' }} /></IconButton>
                                </>
                            }
                            sx={{ position: 'relative', alignItems: 'center', backgroundColor: this.state.feedbackMsg.severity === 'success' ? '#28ae60' : '#eb5757', color: '#fff', borderRadius: '8px', fontWeight: 500 }}
                        >
                            {this.state.feedbackMsg.text}
                        </MuiAlert>
                    )}
                </MuiDialog>
                {/*=================================== Update License Model ======================================*/}
                {this.state.updateLicenseForm &&
                <Modal size={this.state.updateLicenseModalMaximized ? null : "lg"} show={this.state.updateLicenseModal} onHide={this.closeUpdateLicenseModal} centered={!this.state.updateLicenseModalMaximized} backdrop="static" className="update-license-modal-wrap" backdropClassName="update-license-backdrop" dialogClassName={`profile-settings-modal update-license-modal ${this.state.updateLicenseModalMaximized ? "modal-fullscreen" : ""}`}>
                    <Modal.Header style={styles.modal_header}>
                        <Modal.Title>{(this.state.updateLicenseForm && this.state.updateLicenseForm.id) ? 'Update License' : 'Add License'}</Modal.Title>
                        <div style={{ marginLeft: 'auto', display: 'flex' }}>
                            <IconButton size="small" aria-label={this.state.updateLicenseModalMaximized ? "exit fullscreen" : "fullscreen"} onClick={() => this.setState(prevState => ({ updateLicenseModalMaximized: !prevState.updateLicenseModalMaximized }))}>
                                {this.state.updateLicenseModalMaximized ? <FullscreenExitIcon /> : <FullscreenIcon />}
                            </IconButton>
                            <IconButton size="small" aria-label="close" onClick={this.closeUpdateLicenseModal}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                    </Modal.Header>
                    <Modal.Body style={{ width: '100%' }}>
                        <div className="profile-body-content">
                        <div className="profile-fields-padded" style={{paddingTop: 20}}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Agent License Number"
                                    variant="filled"
                                    fullWidth
                                    value={this.state.updateLicenseForm.licenceNumber}
                                    onChange={(e) => this.handleUpdateLicenseField('licenceNumber', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl variant="filled" fullWidth>
                                    <InputLabel>State of Agent License</InputLabel>
                                    <Select value={this.state.updateLicenseForm.stateCode} onChange={this.handleUpdateLicenseStateChange}>
                                        {this.state.updateLicenseStates.map(s => (
                                            <MenuItem key={s.stateCode} value={s.stateCode}>{s.stateName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Grid item xs={12} sm={6}>
                                <DatePicker
                                    label="Agent License Effective Date"
                                    format="MM/DD/YYYY"
                                    value={this.state.updateLicenseForm.effectiveDate ? dayjs(this.state.updateLicenseForm.effectiveDate) : null}
                                    onChange={(date) => this.handleUpdateLicenseField('effectiveDate', (date && date.isValid()) ? date.format('YYYY-MM-DD') : '')}
                                    slotProps={{ textField: { variant: 'filled', fullWidth: true,
                                        // Same rule isUpdateLicenseFormValid uses to disable UPDATE.
                                        ...((this.state.updateLicenseForm.effectiveDate && this.state.updateLicenseForm.expiryDate && this.state.updateLicenseForm.expiryDate < this.state.updateLicenseForm.effectiveDate)
                                            ? { error: true, helperText: 'Effective date cannot be later than the expiry date.' } : {}) } }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <DatePicker
                                    label="Agent License Expiry Date"
                                    format="MM/DD/YYYY"
                                    minDate={this.state.updateLicenseForm.effectiveDate && dayjs(this.state.updateLicenseForm.effectiveDate).isAfter(dayjs(), 'day') ? dayjs(this.state.updateLicenseForm.effectiveDate) : dayjs()}
                                    value={this.state.updateLicenseForm.expiryDate ? dayjs(this.state.updateLicenseForm.expiryDate) : null}
                                    onChange={(date) => this.handleUpdateLicenseField('expiryDate', (date && date.isValid()) ? date.format('YYYY-MM-DD') : '')}
                                    slotProps={{ textField: { variant: 'filled', fullWidth: true } }}
                                />
                            </Grid>
                            </LocalizationProvider>
                            <Grid item xs={12} sm={6}>
                                <input accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" style={{ display: 'none' }} id="license-doc-upload" type="file" onChange={this.handleUpdateLicenseDocChange} />
                                <label htmlFor="license-doc-upload" style={{ display: 'block' }}>
                                    <TextField
                                        label="Agent License Document"
                                        variant="filled"
                                        fullWidth
                                        onClick={() => document.getElementById('license-doc-upload').click()}
                                        value={this.state.updateLicenseDocUploading ? '' : (this.state.updateLicenseForm.fileName || '')}
                                        InputProps={{
                                            readOnly: true,
                                            endAdornment: this.state.updateLicenseDocUploading ? (
                                                <CircularProgress size={18} />
                                            ) : (
                                                <React.Fragment>
                                                    {this.state.updateLicenseForm.fileName && <CheckCircleIcon style={{ fontSize: 20, color: '#4caf50', marginRight: 8 }} />}
                                                    <FileUploadTwoToneIcon style={{ fontSize: 20, color: '#1a2c40' }} />
                                                </React.Fragment>
                                            )
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    />
                                </label>
                                <div style={{ marginTop: 4, fontSize: '8px', color: '#666', lineHeight:1.66,fontFamily:'Roboto'}}>Supported: PDF, DOC, DOCX, JPG, PNG (max 25 MB)</div>
                            </Grid>
                            {this.state.updateLicenseDocErr && (
                                <Grid item xs={12}>
                                    <span style={{ color: '#f44336', fontSize: '12px' }}>{this.state.updateLicenseDocErr}</span>
                                </Grid>
                            )}
                        </Grid>
                        </div>
                        <Grid container direction="row" justify="flex-end" spacing={2} className="profile-footer-row">
                            <Grid item>
                                <CustomButton style={{ height: '40px' }} onClick={this.closeUpdateLicenseModal}>CANCEL</CustomButton>
                            </Grid>
                            <Grid item>
                                <NextButton style={{ margin: '0', width: '95px', height: '40px' }} disabled={!this.isUpdateLicenseFormValid() || this.state.updateLicenseSaving} onClick={this.saveUpdateLicense}>{this.state.updateLicenseSaving ? 'Updating...' : 'UPDATE'}</NextButton>
                            </Grid>
                        </Grid>
                        </div>
                    </Modal.Body>
                </Modal>}
                {/*=================================== Profile Model ======================================*/}
                <Modal size="lg" show={this.state.empProfileModal} onHide={() => this.setState({ empProfileModal: false, loaderShow: false }, () => this.clearData())} centered backdrop="static">
                    <Modal.Header style={styles.modal_header} closeButton>
                        <Modal.Title>Employer Profile</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ width: '100%' }}>
                        {
                            this.state.loaderShow ? <Loader></Loader> : ''
                        }

                        <Grid container spacing={2} justify='center'>
                            <Grid item xs={12} sm={5} >
                                <SampleName setChild={this.setUserValue.bind(this)} reqFlag={true} name={'firstname'} label={'First Name'} value={this.state.fname} disable={true} style={customStyle.textFieldWrpAgent} length={25} fieldType={'fullName'} errMsg={'Enter valid first name'} helperMsg={'First name required'} parentDetails={{ name: 'firstname' }}></SampleName>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <SampleName setChild={this.setUserValue.bind(this)} reqFlag={true} name={'lastname'} label={'Last Name'} value={this.state.lname} disable={true} style={customStyle.textFieldWrpAgent} length={25} fieldType={'fullName'} errMsg={'Enter valid last name'} helperMsg={'Last name required'} parentDetails={{ name: 'lastname' }}></SampleName>
                            </Grid>
                            <Grid item xs={12} sm={5} >
                                <Sample setChild={this.setUserValue.bind(this)} reqFlag={true} name={'email'} label={'Email ID'} value={this.state.email} disable={true} style={customStyle.textFieldWrpAgent} length={50} fieldType={'email'} errMsg={'Enter valid email Id'} helperMsg={'Email Id required'} parentDetails={{ name: 'email' }}></Sample>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <div>
                                    <MuiPhoneNumber
                                        name={"phone"}
                                        id="filled-required"
                                        label={"Mobile No."}
                                        data-cy="user-phone"
                                        variant="filled"
                                        defaultCountry={"us"}
                                        onlyCountries={["us"]}
                                        autoComplete='off'
                                        value={this.state.phone}
                                        length={17}
                                        onChange={(e) => this.setUserValue(e, true, { name: 'phone' })}
                                        disabled={true}
                                        required={true}
                                        style={customStyle.textFieldWrpAgent}
                                        fieldType={'phone'}
                                        errMsg={'Enter valid mobile no.'}
                                        helperMsg={'Mobile no. required'}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={10} >
                            </Grid>

                        </Grid>
                        
                        <hr />
                        <Grid
                            spacing={1}
                            container
                            direction="row"
                            style={{ display: 'flex', justifyContent: 'flex-end' }}
                        >
                            <Grid item xs={12} sm={2}>
                                <CustomButton style={{ height: '40px' }} onClick={() => this.setState({ empProfileModal: false, loaderShow: false }, () => this.clearData())}>CANCEL</CustomButton>
                            </Grid>
                        </Grid>

                    </Modal.Body>
                </Modal>

                {/*=================================== Crop Modal ======================================*/}
                <Modal size="lg" show={this.state.cropModal} onHide={this.handleCropCancel} centered backdrop="static">
                    <Modal.Header style={styles.modal_header} closeButton>
                        <Modal.Title>Crop Profile Picture</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ width: '100%' }}>
                        <div style={{ fontSize: '14px', marginBottom: '15px', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                            <div><strong>File:</strong> {this.state.selectedFile?.name}</div>
                            <div><strong>Size:</strong> {(this.state.selectedFile?.size / (1024 * 1024)).toFixed(2)} MB</div>
                            <div><strong>Format:</strong> {this.state.selectedFile?.type}</div>
                            <div style={{ marginTop: '8px', color: '#666' }}>
                                <strong>Supported:</strong> JPG, JPEG, PNG | <strong>Max Size:</strong> 5MB
                            </div>
                        </div>
                        <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                            <div style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
                                Drag the crop box to select the area you want and use corners to resize the square shape.
                            </div>
                            {this.state.imageSrc && (
                                <div 
                                    style={{ 
                                        display: 'inline-block', 
                                        position: 'relative', 
                                        maxWidth: '100%',
                                        cursor: this.state.isDragging ? 'grabbing' : 'default'
                                    }}
                                    onMouseDown={this.handleMouseDown}
                                    onMouseMove={this.handleMouseMove}
                                    onMouseUp={this.handleMouseUp}
                                    onMouseLeave={this.handleMouseUp}
                                >
                                    <img 
                                        id="cropImage"
                                        src={this.state.imageSrc} 
                                        alt="Preview" 
                                        style={{ 
                                            maxWidth: '100%', 
                                            maxHeight: '400px',
                                            display: 'block',
                                            border: '2px solid #ddd',
                                            borderRadius: '8px',
                                            userSelect: 'none'
                                        }}
                                        onLoad={this.initializeCropBox}
                                        draggable={false}
                                    />
                                    {/* Crop overlay */}
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        pointerEvents: 'none'
                                    }}>
                                        {/* Dark overlay */}
                                        <div style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundColor: 'rgba(0, 0, 0, 0.5)'
                                        }}></div>
                                        {/* Clear crop area */}
                                        <div style={{
                                            position: 'absolute',
                                            left: this.state.cropBox.x,
                                            top: this.state.cropBox.y,
                                            width: this.state.cropBox.width,
                                            height: this.state.cropBox.height,
                                            border: '2px solid #fff',
                                            boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.5)',
                                            cursor: 'move',
                                            pointerEvents: 'auto'
                                        }}>
                                            {/* Corner resize handles */}
                                            <div 
                                                onMouseDown={(e) => this.handleMouseDown(e, 'nw')}
                                                style={{ 
                                                    position: 'absolute', 
                                                    top: -6, 
                                                    left: -6, 
                                                    width: 12, 
                                                    height: 12, 
                                                    backgroundColor: '#2e3192', 
                                                    border: '2px solid #fff',
                                                    cursor: 'nwse-resize',
                                                    borderRadius: '2px'
                                                }}></div>
                                            <div 
                                                onMouseDown={(e) => this.handleMouseDown(e, 'ne')}
                                                style={{ 
                                                    position: 'absolute', 
                                                    top: -6, 
                                                    right: -6, 
                                                    width: 12, 
                                                    height: 12, 
                                                    backgroundColor: '#2e3192', 
                                                    border: '2px solid #fff',
                                                    cursor: 'nesw-resize',
                                                    borderRadius: '2px'
                                                }}></div>
                                            <div 
                                                onMouseDown={(e) => this.handleMouseDown(e, 'sw')}
                                                style={{ 
                                                    position: 'absolute', 
                                                    bottom: -6, 
                                                    left: -6, 
                                                    width: 12, 
                                                    height: 12, 
                                                    backgroundColor: '#2e3192', 
                                                    border: '2px solid #fff',
                                                    cursor: 'nesw-resize',
                                                    borderRadius: '2px'
                                                }}></div>
                                            <div 
                                                onMouseDown={(e) => this.handleMouseDown(e, 'se')}
                                                style={{ 
                                                    position: 'absolute', 
                                                    bottom: -6, 
                                                    right: -6, 
                                                    width: 12, 
                                                    height: 12, 
                                                    backgroundColor: '#2e3192', 
                                                    border: '2px solid #fff',
                                                    cursor: 'nwse-resize',
                                                    borderRadius: '2px'
                                                }}></div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <CustomButton onClick={this.handleCropCancel} style={{ minWidth: '150px' }}>CANCEL</CustomButton>
                        <NextButton onClick={this.handleCropSave} style={{ marginLeft: '10px', minWidth: '150px' }}>SAVE & UPLOAD</NextButton>
                    </Modal.Footer>
                </Modal>
            </div>

        )
    }
}

export default withRouter(Header);